import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

// Base selector
const selectWorkflowIssuesState = (state: RootState) => state.workflowIssues;

// Derived selectors
export const selectConflicts = createSelector(
	[selectWorkflowIssuesState],
	(state) => state.conflicts,
);

export const selectImprovements = createSelector(
	[selectWorkflowIssuesState],
	(state) => state.improvements,
);

export const selectIsLoading = createSelector(
	[selectWorkflowIssuesState],
	(state) => state.isLoading,
);

export const selectError = createSelector([selectWorkflowIssuesState], (state) => state.error);

export const selectConflictCount = createSelector(
	[selectConflicts],
	(conflicts) => conflicts.length,
);

export const selectImprovementCount = createSelector(
	[selectImprovements],
	(improvements) => improvements.length,
);

export const selectHasIssues = createSelector(
	[selectConflictCount, selectImprovementCount],
	(conflictCount, improvementCount) => conflictCount > 0 || improvementCount > 0,
);
